import { computed, ref, watch } from "vue";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useNgSession } from "@sazka/ng/ng-session";
import { fetchFsPlayerStatus } from "@/loyalty/api/loyalty-api";
import { FsPlayerDataStatus } from "@/loyalty/api/models/fs-player-status";

const maxFsPoints = 10;

const { isLoggedIn } = useNgSession();

const isFsPlayerDataLoaded = ref(false);
const fsPlayerDataHasError = ref(false);

const fsPlayerData = ref<FsPlayerDataStatus>({
    access: false,
    allowedToday: false,
    points: 0,
});

const hasMaxPoints = computed(() => fsPlayerData.value?.points >= maxFsPoints);

async function loadFsPlayerData() {
    try {
        fsPlayerData.value = await fetchFsPlayerStatus();
        fsPlayerDataHasError.value = false;
        isFsPlayerDataLoaded.value = true;
    } catch (err) {
        fsPlayerDataHasError.value = true;
        console.error(err);
    }
}

function updateFsPoints(newPoints: number) {
    fsPlayerData.value.points = newPoints;
}
function updateFsData(newPoints: number, access: boolean) {
    fsPlayerData.value.points = newPoints;
    fsPlayerData.value.access = access;
}

async function initFsPlayerStatus() {
    await ngFrameworkLoaded();

    watch(
        isLoggedIn,
        async (newIsloggedIn) => {
            if (newIsloggedIn) {
                await loadFsPlayerData();
            } else {
                isFsPlayerDataLoaded.value = false;
            }
        },
        { immediate: true }
    );
}

export default {
    isFsPlayerDataLoaded,
    fsPlayerData,
    hasMaxPoints,
    maxFsPoints,

    initFsPlayerStatus,
    loadFsPlayerData,
    updateFsPoints,
    updateFsData,
};
